import React, { useEffect, useRef } from "react";
import { motion, useAnimation } from "framer-motion";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import "./Sliders.css";
import { useLanguage } from "../../context/LanguageContext";
import { getT } from "../../translations";

gsap.registerPlugin(ScrollTrigger);

const images = [
  "https://res.cloudinary.com/dep7dpjup/image/upload/v1772595790/WhatsApp_Image_2026-03-03_at_6.33.44_PM_lyy3cr.jpg",
"https://res.cloudinary.com/dep7dpjup/image/upload/v1772610768/From_KlickPin_CF_NAILONG_HAS_HANDS_in_2026_jf51hx.jpg",
"https://res.cloudinary.com/dep7dpjup/image/upload/v1772610743/From_KlickPin_CF_Pin_on_owannuraqilah12345_imyty5.jpg",
"https://res.cloudinary.com/dep7dpjup/image/upload/v1772610743/From_KlickPin_CF_Pin_di_Chubby_Yellow_Dinosaur_wvzkwd.jpg",
"https://res.cloudinary.com/dep7dpjup/image/upload/v1772610742/From_KlickPin_CF_Pin_by_Lindsay_on_Pins_by_you___Cute_funny_pics_Cute_memes_Funny_emoji_h0q1zj.jpg",
"https://res.cloudinary.com/dep7dpjup/image/upload/v1772610743/From_KlickPin_CF_Pin_di_Dino_Yellow_Ava_Couple_xatj9u.jpg",
"https://res.cloudinary.com/dep7dpjup/image/upload/v1772610742/From_KlickPin_CF_Pin_on_owannuraqilah12345_1_uh5ytl.jpg",
"https://res.cloudinary.com/dep7dpjup/image/upload/v1772610742/From_KlickPin_CF_Pin_on_awannuraqilah12345_hd5ejr.jpg",




];

function Sliders() {
  const sectionRef = useRef(null);
  const leftRef = useRef(null);
  const rightRef = useRef(null);
  const { lang } = useLanguage();
  const t = getT(lang);
  const controls1 = useAnimation();
  const controls2 = useAnimation();

  useEffect(() => {
    const animateSlider = async () => {
      while (true) {
        await controls1.start({
          y: ["0%", "-50%"],
          transition: { duration: 15, ease: "linear", repeat: Infinity },
        });
      }
    };

    const animateSlider2 = async () => {
      while (true) {
        await controls2.start({
          y: ["-50%", "0%"],
          transition: { duration: 15, ease: "linear", repeat: Infinity },
        });
      }
    };

    animateSlider();
    animateSlider2();
  }, [controls1, controls2]);

  useEffect(() => {
    const section = sectionRef.current;
    const left = leftRef.current;
    const right = rightRef.current;
    if (!section || !left || !right) return;
    gsap.set([left, right], { opacity: 0, y: 36 });
    const tl = gsap.timeline({
      scrollTrigger: { trigger: section, start: "top 82%", toggleActions: "play none none none" },
    });
    tl.to(left, { opacity: 1, y: 0, duration: 0.65, ease: "power2.out" })
      .to(right, { opacity: 1, y: 0, duration: 0.6, ease: "power2.out" }, "-=0.4");
    return () => ScrollTrigger.getAll().forEach((t) => t.kill());
  }, []);

  return (
    <div id="story" ref={sectionRef} className="container-fluid slider-section">
      <div className="row align-items-start">
        <div ref={leftRef} className="col-md-6 story-section">
             <h2 className="story-cardh2">{t("story.title")}</h2>
             <br/>
<div className="story-card">


  <p>{t("story.p1")}</p>

  <p>{t("story.p2")}</p>

  <p>{t("story.p3")}</p>

  <p>
    {(() => {
      const p4 = t("story.p4");
      const sep = "奶龙 Milk Dragon";
      const i = p4.indexOf(sep);
      if (i === -1) return p4;
      return <>{p4.slice(0, i)}<strong>{sep}</strong>{p4.slice(i + sep.length)}</>;
    })()}
  </p>
</div>


          <div className="bottom-image">
            <img
              src="https://res.cloudinary.com/dep7dpjup/image/upload/v1772611075/From_KlickPin_CF_NAAAIILLLOOONGGG___Cute_funny_pics_Funny_emoticons_Image_fun-removebg-preview_tic0py.png"
              alt="Lofi main"
            />
          </div>
        </div>

        <div ref={rightRef} className="col-md-6 sliders-wrapper">
          <div className="blur-overlay top"></div>
          <div className="blur-overlay bottom"></div>

          {/* Slider 1 (scrolls upward) */}
          <div className="slider-container">
            <motion.div className="slider" animate={controls1}>
              {[...images, ...images].map((img, i) => (
                <img src={img} alt="" key={i} />
              ))}
            </motion.div>
          </div>

          {/* Slider 2 (scrolls downward) */}
          <div className="slider-container">
            <motion.div className="slider" animate={controls2}>
              {[...images, ...images].map((img, i) => (
                <img src={img} alt="" key={i} />
              ))}
            </motion.div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Sliders;
